import { CardConfig } from '@affinis/smartus-components/lib/card/card.component.types';
import { Component } from '@angular/core';
import { BreadcrumbService } from '@core/services/breadcrumb-service/BreadcrumbService';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-support-telekom',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  standalone: false,
})
export class SupportTelekomComponent {
  headline = this.translateService.instant('menu.support.support_action');
  cardSupport: CardConfig = {
    header: {
      title: {
        label: this.translateService.instant('support.headline'),
      },
    },
  };

  constructor(
    private translateService: TranslateService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumbService.setBreadcrumbs([{ label: this.headline }]);
  }

  public get mailAddress(): string {
    return this.translateService.instant('support.mailAddress');
  }
}
